var adapterRegistry = new Map();
export function registerChartAdapter(adapter) {
    if (adapterRegistry.has(adapter.type)) {
        if (process.env.NODE_ENV !== "production") {
            console.warn("[CompsChart] \u56FE\u8868\u7C7B\u578B \"".concat(adapter.type, "\" \u5DF2\u6CE8\u518C\uFF0C\u5C06\u8986\u76D6\u73B0\u6709\u9002\u914D\u5668"));
        }
    }
    adapterRegistry.set(adapter.type, adapter);
}
export function getChartAdapter(type) {
    var adapter = adapterRegistry.get(type);
    if (!adapter) {
        throw new Error("[CompsChart] \u672A\u627E\u5230\u56FE\u8868\u7C7B\u578B \"".concat(type, "\" \u7684\u9002\u914D\u5668"));
    }
    return adapter;
}
export function isChartTypeRegistered(type) {
    return adapterRegistry.has(type);
}
export function listChartTypes() {
    return Array.from(adapterRegistry.keys());
}
